import styled from 'styled-components';

export const Input = styled.input<{ disabled?: boolean; error?: string }>`
  width: 100%;
  height: 48px;
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
  border-radius: 4px;
  color: var(--colorBlueGray1200);
  background-color: var(--colorBlueGray50);
  border: 1px solid ${({ error }) => (error ? 'var(--colorWarning)' : 'rgb(213, 215, 216)')};
  padding: 7px 16px 9px;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: var(--letterSpacing);
  line-height: 20px;
  outline: none;
  transition: border-color 0.2s ease-in-out;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:focus {
    border-color: var(--colorBlueGray1200) !important;
  }
`;

export const RadioButton = styled.input`
  cursor: pointer;
  margin-right: 10px;
  accent-color: var(--colorBlueGray900);
`;
